import { Box, Typography } from "@mui/material"
import { useEffect, useState } from 'react'
import { useGetIdentity, useNotify, usePermissions } from 'react-admin'
import { apiService } from '../apiService'
import { Permissions } from "../authentication/Permissions"
import OrderSubscriptionButton from "../users/subscriptions/OrderSubscriptionButton"

const InfoTotalInvoiceCount = () => {

  const notify = useNotify()
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const { isLoading: permissionsLoading, permissions } = usePermissions<Permissions>({}, {
    onError(err) {
      notify("Failed to fetch permissions", {type: "error"})
    },
  })
  
  const [loading, setLoading] = useState<boolean>(true)
  const [leftInvoices, setLeftInvoices] = useState<number | undefined>()

  const fetchTotalInvoiceCount = async() => {
    try {
      var {data: totalInvoiceCount} = await apiService.InvoicesApi.getTotalInvoiceCountForMontAndYear({userId: identity?.id.toString()})
      setLeftInvoices(3 - totalInvoiceCount < 0 ? 0 : 3 - totalInvoiceCount)  
      setLoading(false)
    } catch (error) {
      notify("Failed to fetch totalInvoiceCount", {type: "error"})
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTotalInvoiceCount()
  }, [])

  if(identityLoading || permissionsLoading) return null

  return (
    <Box>
      {
        permissions?.freeUser &&
        <Box display={"flex"} justifyContent={"flex-end"} height={35} pt={2} pr={2}>
          {
            !loading && 
            <>
              <Typography>Du kannst diesen Monat noch <strong>{leftInvoices}</strong> {`Rechnung${(leftInvoices&&leftInvoices===1) ? "" : "en"}`} schreiben.</Typography>
              <OrderSubscriptionButton />
            </>
            
          }
        </Box>
      }
    </Box>
  )
}

export default InfoTotalInvoiceCount